import { gql } from 'apollo-angular'

export default gql`
  mutation edit_report_by_pk($id: Int!, $_set: report_set_input) {
    update_report(where: { id: { _eq: $id } }, _set: $_set) {
      affected_rows
      returning {
        id
      }
    }
  }
`
